import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export const getAccounts = () => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_accounts'
    })
  }
);

export const getAccountById = id => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_account_by_id',
      id,
    })
  }
);

export const getAccountPassword = (id, login) => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_account_password',
      login,
      id,
    })
  }
);

export const postAccounts = formData => {
  formData.append('operation', 'load_ai_accounts')
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: formData,
    }
  );
};

export const getAccountsHistory = id => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_account_history',
      account_id: id,
    })
  }
);

export const getAccountsHistoryById = id => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_account_history_by_id',
      id,
    })
  }
);

export const getProviders = () => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'get_ai_providers'
    })
  }
);

export const addAiAccount = (login, password, isSuper, providerId) => sendRequestWithAuth(
  settings.ServerURL, {
    method: 'POST',
    body: JSON.stringify({
      operation: 'add_ai_account',
      login,
      password,
      super: isSuper,
      provider_id: providerId
    })
  }
);



// WEBPACK FOOTER //
// ./src/services/accounts.js